import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>No más IBEX 35</h1>
            </header>
            <div className="content">
                <p>Un sitio web responsable donde encontrarás<br />
                alternativas más éticas a las empresas del IBEX 35</p>
                <ul className="actions">
                    <li><a href="#one" className="button next scrolly">Empezar</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
